/**
 * @param domElementOrId DOM element or an html id
 * @return true if the element is currenlty focused
 */
export function isFocused(domElementOrId: Element | string) {
    const domElement = (domElementOrId instanceof Element ? domElementOrId : document.getElementById(domElementOrId));
    return (domElement && document.activeElement?.id === domElement.id);
}
